import { useRef, useState } from "react";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

export default function CameraPanel() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [letter, setLetter] = useState("");
  const [sentence, setSentence] = useState("");

  const startCamera = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });

    videoRef.current.srcObject = stream;
  };

  const capture = async () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    const ctx = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    ctx.drawImage(video, 0, 0);

    canvas.toBlob(async (blob) => {
      const formData = new FormData();

      formData.append("file", blob, "frame.jpg");

      const res = await fetch(`${apiBaseUrl}/predict`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      setLetter(data.prediction);

      setSentence((prev) => prev + data.prediction);
    });
  };

  return (
    <div className="section-shell px-6 pb-16">
      <video
        ref={videoRef}
        autoPlay
        className="camera-frame mx-auto rounded-[2rem] border border-[rgba(107,79,47,0.18)] object-cover shadow-[0_24px_60px_rgba(79,45,19,0.14)]"
      />

      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <button onClick={startCamera} className="cta-primary">
          Start Camera
        </button>

        <button
          onClick={capture}
          className="rounded-full bg-[var(--accent)] px-6 py-4 font-semibold text-white shadow-[0_18px_40px_rgba(31,108,99,0.24)] transition hover:-translate-y-0.5"
        >
          Predict
        </button>
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <div className="info-panel rounded-[1.5rem] p-6 text-left">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-500">
            Detected Letter
          </p>
          <h2 className="mt-4 text-4xl text-stone-900">
            {letter || "Waiting for capture"}
          </h2>
        </div>

        <div className="info-panel rounded-[1.5rem] p-6 text-left">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-500">
            Sentence
          </p>
          <h3 className="mt-4 min-h-12 text-2xl text-stone-800">
            {sentence || "Predictions will accumulate here."}
          </h3>
        </div>
      </div>

      <div className="result-chip mx-auto mt-6 inline-flex rounded-full px-4 py-2 text-sm font-semibold">
        Capture a frame after the camera stream is active.
      </div>

      <canvas ref={canvasRef} className="hidden" />
    </div>
  );
}
